module.exports = __webpack_public_path__ + "static/media/question.4994aff8.svg";